import styled, { css } from 'styled-components';

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: ${props => props.small ? 'unset' : '190px'};
  padding: ${props => {
    if (props.outlined) return '5px 18px';
    if (props.small) return '6px 19px';
    if (props.flat) return '0 4px';
    return '7px 20px';
  }};
  
  /* Base styles */
  font-size: 14px;
  font-weight: 700;
  
  /* Small text styles */
  ${props => props.smallText && css`
    font-size: 12px;
    font-weight: 400;
  `}
  
  line-height: 1.5;
  color: ${props => {
    if (props.outlined) return props.theme.main;
    if (props.variant === 'danger') return props.theme.white;
    return props.theme.white;
  }};
  outline: none;
  border: ${props => props.outlined ? `1px solid ${props.theme.main}` : 'none'};
  border-radius: ${props => props.rounded ? '50px' : '5px'};
  background: ${props => {
    if (props.transparent) return 'transparent';
    if (props.outlined) return props.theme.white;
    if (props.variant === 'danger') return 'linear-gradient(90deg, #FF6B6B 0%, #FF4949 100%)';
    return 'linear-gradient(90deg, #6C90FF 0%, #8566FF 100%)';
  }};
  transition: .3s ease-in;
  pointer-events: ${props => props.disabled ? 'none' : 'auto'};
  opacity: ${props => props.disabled ? '0.5' : '1'};
  cursor: pointer;
  
  &:hover {
    background: ${props => {
      if (props.variant === 'danger') return 'linear-gradient(90deg, #FF4949 0%, #FF3333 100%)';
      return 'var(--bllink-gradient-primary)';
    }};
    color: ${props => props.theme.white};
  }
  
  &.flat {
    border: none;
    background: ${props => {
        if (props.transparent) return 'transparent';
        return props.theme.white;
    }};
    border-radius: 0;
    padding: 0 4px;
    min-width: fit-content;
    color: ${props => props.theme.main};
    border-bottom: ${props => {
        if (props.transparent) return '';
        return `1px solid ${props.theme.main}`;
    }};
    
    &:hover {
      background: ${props => props.theme.white};
      color: ${props => props.theme.main};
    }
  }
  
  .btn-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-inline-start: 25px;
    width: 27px;
    height: 27px;
    border-radius: 50%;
    background: #9175FF;
    transform: ${props => props.rtl ? 'none' : 'rotate(180deg)'};
    box-shadow: 0 3px 25px rgba(76, 18, 171, .81);
  }
`;

export default function Button({
  children,
  type,
  onClick,
  className = '',
  outlined,
  rounded = true,
  smallText = false,
  flat,
  small,
  disabled,
  rtl,
  fontBig,
  considerForArrowInCircle,
  variant,
  transparent = false,
  
}) {
  
  return (
    <StyledButton
      type={type}
      className={`${className} ${flat ? 'flat' : ''} app-btn`}
      onClick={onClick}
      outlined={outlined}
      rounded={rounded}
      small={small}
      fontBig={fontBig}
      disabled={disabled}
      considerForArrowInCircle={considerForArrowInCircle}
      rtl={rtl}
      variant={variant}
      transparent={transparent}
      smallText={smallText}
    >
      {children}
    </StyledButton>
  );
}
